<template>
  <div class="absolute" :style="{ top: y + 'px', left: x + 'px' }">
    <img
      src="@/assets/images/map/qlogo.png"
      class="rounded-full w-[50px] cursor-pointer himg"
      alt=""
      @click="setDetails(station)"
    />
    <div
      class="pop z-30 -left-[125px] bg-white text-[#5E5E5E] rounded-2xl overflow-hidden max-w-sm"
      :style="{
        ...(y > 530
          ? { bottom: '60px', position: 'absolute' }
          : { position: 'relative' }),
      }"
    >
      <img :src="img" class="min-w-[300px]" alt="" />
      <div class="p-4 bg-white flex-col flex gap-2">
        <h4 class="font-medium font-inter text-realBlack">
          {{ details.name }}
        </h4>
        <div class="flex items-start gap-2">
          <GPS />
          <p class="text-xs">{{ details.address }}</p>
        </div>
        <div class="flex items-start gap-2">
          <ChargingBattery />
          <p class="text-xs">{{ details.chargers }}</p>
        </div>
        <div class="flex items-center gap-2">
          <p class="text-xs font-medium">
            <span v-if="isOpen.isOpen" class="text-[#198639]">{{
              "Open"
            }}</span>
            <span v-else class="text-red">{{ "Closed" }}</span>
          </p>
          <span class="w-[2px] h-[2px] bg-[#5E5E5E] inline-block"></span>
          <p class="text-xs font-medium">
            {{ isOpen.text }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ChargingBattery from "./ChargingBattery.vue";
import GPS from "./GPS.vue";

export default {
  components: { GPS, ChargingBattery },
  props: ["y", "x", "img", "details", "setDetails", "station"],
  computed: {
    isOpen() {
      return this.$store.getters.isOpen(this.details.openHours);
    },
  },
};
</script>

<style scoped>
.pop {
  display: none;
}

.himg:hover + .pop {
  display: block;
}
</style>